module.exports = __webpack_public_path__ + "media/images/notification-157128b376cee7678c6e8be35c4385b3.jpeg";